import { Subject } from 'rxjs';
import { Component, OnInit, Input, Output } from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent implements OnInit {
  @Input() totalNumber: number;
  @Input() pageSize: number;
  @Input() currentPageIndex: number;
  @Output() pageIndexChange: Subject<number> = new Subject<number>();

  constructor() {}

  ngOnInit(): void {}

  showPageClick(newPageIndex: number): void {
    this.currentPageIndex = newPageIndex;
    this.pageIndexChange.next(this.currentPageIndex);
  }

  showNext(): boolean {
    if (this.totalNumber == null || this.pageSize == null || this.currentPageIndex == null) {
      return false;
    }
    return (this.currentPageIndex + 1) * this.pageSize < this.totalNumber;
  }
}
